import { StaticBase } from './static-base';
import { AppCacheService } from '../cache/app-cache.service';
import { TypeRefs } from '../../../shared/models/static-data';

export class TypeRef extends StaticBase {
  private selectorPropertyName: string;

  constructor(
    private selectorName: string,
    private propertyName: string,
    private storageCache: AppCacheService
  ) {
    super(selectorName, storageCache);
    this.selectorPropertyName = propertyName;
  }

  /**
   * Gets typeref object by code
   */
  get(typeCode: number): TypeRefs {
    return this.getItem(this.selectorPropertyName, typeCode);
  }

  /**
   * Gets typeref object collection by group code
   */
  byGroup(groupCode: number): Array<TypeRefs> {
    const itemData = this.getData();
    let typeRefs: Array<any> = [];

    if (itemData && itemData.length > 0) {
      typeRefs = itemData
        .filter(item => item.typeGroupCode === groupCode)
        .sort((item1, item2) => item1.typeCode - item2.typeCode);
    }

    return typeRefs;
  }
}
